<template>
  <div class="xv_view" id="Cases_G">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Cases</label>
      </div>
      <div class="xv_actions"></div>
    </div>

    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Cases (4)</span>
        </div>
        <div>
          <button class="sec_btn" @click="table_filter()">
            Filter
            <span class="mdi mdi-filter-menu"></span>
          </button>
        </div>
      </div>

      <div class="filter_wrap">
        <div class="left_filter" v-if="left_filter == true">
          <div class="header_section top">
            <div>
              <span class="main_title">
                Filter
                <span class="mdi mdi-filter-menu"></span>
              </span>
            </div>
            <div>
              <span class="option">Reset</span>
            </div>
          </div>
          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Date</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="xv_datepicker">
                <span class="mdi mdi-calendar-month"></span>
                <vc-date-picker
                  mode="range"
                  v-model="selectedDate"
                  :popover="{ visibility: 'click' }"
                  :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select dates',
                    readonly: true
                  }"
                  :masks="{ input: 'DD/MM/YY' }"
                />
              </div>
            </div>
          </div>
          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Employee</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <input type="text" placeholder="Employee" />
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Office</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <multiselect
                v-model="multiselect"
                :options="[
                  'Alphabet',
                  'Nestle',
                  'Tencent',
                  'Facebook',
                  'Alibaba'
                ]"
                :multiple="true"
              ></multiselect>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Type</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">High Temperature</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Low XV Score</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-7" name="checkbox-7"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Quarantine Contact</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-8" name="checkbox-8"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Traveled to Korea</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table class="cases_table_g">
          <thead>
            <tr>
              <th style>Date/Time</th>
              <th style="text-align:center">Citizen</th>
              <th style="text-align:center">Phone</th>
              <th style="text-align:center">Id</th>
              <th style="text-align:center">Actions</th>
              <th style="text-align:center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Jules Case</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td>
                <b-dropdown split split-href="#" text="House visit" class="xv_drop m-2">
                  <b-dropdown-item href="#">Home Quarantin</b-dropdown-item>
                  <b-dropdown-item href="#">Move to Quarantine Center</b-dropdown-item>
                  <b-dropdown-item href="#">Quarantine</b-dropdown-item>
                  <b-dropdown-item href="#">Quarantine Violationn</b-dropdown-item>
                </b-dropdown>
              </td>
              <td class="status_1">
                <span>Ok</span>
              </td>
            </tr>

            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Ajay Herman</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td>
                <b-dropdown split split-href="#" text="House visit" class="xv_drop m-2">
                  <b-dropdown-item href="#">Home Quarantin</b-dropdown-item>
                  <b-dropdown-item href="#">Move to Quarantine Center</b-dropdown-item>
                  <b-dropdown-item href="#">Quarantine</b-dropdown-item>
                  <b-dropdown-item href="#">Quarantine Violationn</b-dropdown-item>
                </b-dropdown>
              </td>
              <td class="status_2">
                <span>Block</span>
              </td>
            </tr>

            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Gurdeep Stevens</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td>
                <b-dropdown split split-href="#" text="House visit" class="xv_drop m-2">
                  <b-dropdown-item href="#">Home Quarantin</b-dropdown-item>
                  <b-dropdown-item href="#">Move to Quarantine Center</b-dropdown-item>
                  <b-dropdown-item href="#">Quarantine</b-dropdown-item>
                  <b-dropdown-item href="#">Quarantine Violationn</b-dropdown-item>
                </b-dropdown>
              </td>
              <td class="status_1">
                <span>Ok</span>
              </td>
            </tr>

            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Kaleb Read</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td>
                <b-dropdown split split-href="#" text="House visit" class="xv_drop m-2">
                  <b-dropdown-item href="#">Home Quarantin</b-dropdown-item>
                  <b-dropdown-item href="#">Move to Quarantine Center</b-dropdown-item>
                  <b-dropdown-item href="#">Quarantine</b-dropdown-item>
                  <b-dropdown-item href="#">Quarantine Violationn</b-dropdown-item>
                </b-dropdown>
              </td>
              <td class="status_2">
                <span>Block</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cases_G",
  components: {},
  data() {
    return {
      selected: null,
      left_filter: false,
      selectedDate: null,
      multiselect: null
    };
  },
  methods: {
    table_filter: function() {
      if (this.left_filter == false) {
        this.left_filter = true;
      } else {
        this.left_filter = false;
      }
    },
    view_citizen: function() {
      this.$router.push("citizens");
    }
  }
};
</script>
